import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex justify-between" }
const _hoisted_2 = ["title"]

import { onMounted } from 'vue';
	import { useRouter } from 'vue-router';
	import { TPublicRoom, useRooms } from '@/store/store';
	import { usePubHubs } from '@/core/pubhubsStore';
	import { buttonsCancel } from '@/store/dialog';
	import { useToggleMenu } from '@/store/toggleGlobalMenu';

	
export default /*#__PURE__*/_defineComponent({
  __name: 'JoinRoom',
  emits: ['close'],
  setup(__props, { emit: __emit }) {

	const rooms = useRooms();
	const router = useRouter();
	const pubhubs = usePubHubs();
	const emit = __emit;
	const toggleMenu = useToggleMenu();

	onMounted(async () => {
		await rooms.fetchPublicRooms();
		toggleMenu.toggleGlobalMenu();
	});

	async function joinRoom(room: TPublicRoom) {
		if (rooms.roomIsSecure(room.room_id)) {
			router.push({ name: 'secure-room', params: { id: room.room_id } });
		} else {
			await pubhubs.joinRoom(room.room_id);
		}
		close();
	}

	async function close() {
		emit('close');
		toggleMenu.toggleGlobalMenu();
	}

return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_FilteredList = _resolveComponent("FilteredList")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    buttons: _unref(buttonsCancel),
    onClose: _cache[1] || (_cache[1] = ($event: any) => (close()))
  }, {
    header: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.$t('rooms.join_room')), 1)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_FilteredList, {
        items: _unref(rooms).visiblePublicRooms,
        sortby: "name",
        placeholder: _ctx.$t('rooms.filter'),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (joinRoom($event)))
      }, {
        item: _withCtx(({ item }) => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_Icon, {
              type: _unref(rooms).roomIsSecure(item.room_id) ? 'lock' : 'room',
              class: "flex-none mr-4 text-green group-hover:text-black"
            }, null, 8, ["type"]),
            _createElementVNode("span", {
              title: item.room_id,
              class: "grow truncate w-100"
            }, _toDisplayString(item.name) + " ", 9, _hoisted_2),
            _createVNode(_component_Icon, {
              type: "plus",
              class: "flex-none"
            })
          ])
        ]),
        _: 1
      }, 8, ["items", "placeholder"])
    ]),
    _: 1
  }, 8, ["buttons"]))
}
}

})